module.exports = __webpack_public_path__ + "img/tzfardea_yes.324e9e4b.png";